module.exports = __webpack_public_path__ + "img/gyny.f9162689.svg";